import { AlarmUpdatesDTO, DataVersion } from '@hakimo-ui/hakimo/types';
import { withDataVersion } from '@hakimo-ui/hakimo/util';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useAlarmUpdates(
  alarmId: string,
  searchParams: string,
  refetchInterval: number,
  dataVersion?: DataVersion
) {
  const url = `/v2/orm/alarm/update/${alarmId}?${searchParams}`;
  const request = new Request(url);
  withDataVersion(request, dataVersion);

  return useAuthenticatedRequest<AlarmUpdatesDTO>(request, {
    queryKey: ['alarm_updates', alarmId, { searchParams, dataVersion }],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    refetchInterval,
  });
}

export default useAlarmUpdates;
